module.exports = {"Operate15":{"daobanList":[{"title":"1:是否新办理人力资源服务许可审批","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、人力资源服务许可的申请书","state":"必要"},{"name":"2、营业执照（副本）复印件","state":"必要"},{"name":"3、场所使用权证明（属于自有产权的，提供合法产权证；属于租赁的，提供经职能部门确认的已签署的租赁合同文本或协议）","state":"必要"},{"name":"4、与开展业务相适应的办公设施设备清单","state":"必要"},{"name":"5、3名以上专职人员的劳动合同或社保情况学证明","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-15.json
// module id = 1272
// module chunks = 0